// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__IdMeK","content":"LayoutSettings_content__BZW_O"};